Dates = require 'lib/dates'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
t = require('views/internal/teacup-with-helpers')('check_item_menu')
track = require 'debug/track'

template = t.renderable ({ editable }) ->
  t.ul '.pop-over-list', ->
    if editable
      t.li ->
        t.a '.js-convert-to-card', { href: '#' }, ->
          t.format 'convert-to-card'

      t.li ->
        t.a '.js-delete', { href: '#' }, 'data-test-id': 'delete-checklist-item', ->
          t.format 'delete'

module.exports = class CheckItemMenuView extends View
  viewTitleKey: 'check item'

  events:
    'click .js-convert-to-card': 'convertToCard'
    'click .js-delete': 'delete'

  render: ->
    @$el.html(template({
      editable: @model.editable()
    }))

    @

  convertToCard: (e) ->
    Util.stop(e)

    @model.run 'convertToCard'
    # Immediately remove from the list
    @model.getChecklist().checkItemList.remove(@model)

    track("Checklist", "Convert Checklist Item to Card")

    PopOver.hide()
    return

  delete: (e) ->
    Util.stop(e)

    @model.destroy()
    track("Checklist", "Delete Single Checklist Item")

    PopOver.hide()
    return




// WEBPACK FOOTER //
// ./app/scripts/views/checklist/check-item-menu-view.coffee